module.exports = __webpack_public_path__ + "img/dreams-mini-portrait.2660303.png";